import { z } from "zod";
import { renderModes, targetDeviceTypes } from "./types";

import { SessionType } from "@/session/types";

export const legacyLaunchPageQueryParamsSchema = z.object({
  device: z
    .enum([
      SessionType.CloudRenderedNonVR,
      SessionType.CloudRenderedVR,
      SessionType.LocallyRenderedStandalone,
      SessionType.LocallyRenderedWindows,
    ])
    .optional(),
  args: z.string().optional(),
  forceColdVm: z.coerce.boolean().optional(),
  vmImage: z.string().optional(),
  region: z.string().optional(),
});

export const launchParamsSchema = z.object({
  appId: z.string().uuid(),
  renderMode: z.enum(renderModes),
  targetDeviceType: z.enum(targetDeviceTypes),
});

export const defaultLaunchQueryParams: {
  args: string;
  forceColdVm: boolean;
} = {
  args: "",
  forceColdVm: false,
};

export const launchQueryParamsSchema = z.object({
  args: z.string().optional().default(defaultLaunchQueryParams.args),
  forceColdVm: z.coerce
    .boolean()
    .optional()
    .default(defaultLaunchQueryParams.forceColdVm),
  encryptVrStream: z.coerce.boolean().optional(),
  useXrGateway: z.coerce.boolean().optional(),
  debugModeEnabled: z.coerce.boolean().optional(),
  virtualMachineId: z.uuid().optional(),
  vmImage: z.string().optional(),
  region: z.string().optional(),
  targetDevice: z.string().optional(),
  buildId: z.coerce.number().optional(),
});
